/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="19.11"
        height="9.32"
        viewBox="0 0 19.11 9.32"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M2.62 7.44a2 2 0 0 0 4 0h6a2 2 0 0 0 4 .05h1.57l.95-3.85-4.6-.92-3.1-2.68H4L.07 3.31 1 7.48Zm2 .88a1 1 0 0 1-1-.78 1 1 0 0 1 .58-1.12.92.92 0 0 1 .36-.07.73.73 0 0 1 .3.06l.17.07a1 1 0 0 1-.47 1.86Zm10 0a1 1 0 1 1 1-1 1 1 0 0 1-1 1ZM4.29 1H11l3 2.62 3.83.77-.51 2.07h-.86a2.13 2.13 0 0 0-1.88-1.2 2.07 2.07 0 0 0-1.88 1.15H6.38l-.12-.16-.1-.14a1.24 1.24 0 0 0-.18-.21 2 2 0 0 0-1.17-.58h-.27a2 2 0 0 0-.67.14l-.16.06a2 2 0 0 0-1 .92h-1l-.63-2.79Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'CarIcon';

export default Icon;
